import polygon from "./polygon.component";

const polygonModule = angular
  .module("app.components.polygon", [])
  .component("polygon", polygon);

export default polygonModule;



// WEBPACK FOOTER //
// ./src/components/polygon/polygon.module.js